<template src="./Dictionary.html"></template>

<script>
import { createNamespacedHelpers } from 'vuex';
import translationsTopMenu from "@/components/translations/components/topMenu";
import Pagination from "@/components/components/pagination";

const { mapGetters, mapActions} = createNamespacedHelpers('translations/dictionary');

export default {
  name: "Dictionary",
  components: {
    translationsTopMenu,
    Pagination
  },
  data () {
    return {
      showOverlay: false,
      type: 'ru',
      fieldsList: [
        {
          key: 'id',
          label: 'Номер записи',
          sortable: true
        },
        {
          key: 'singularKey',
          label: 'Единственное число (ключ)',
          sortable: true
        },
        {
          key: 'pluralKey',
          label: 'Множественное число (ключ)',
          sortable: true
        },
        {
          key: 'singularValue',
          label: 'Единственное число (знач.)',
          sortable: true
        },
        {
          key: 'pluralValue',
          label: 'Множественное число (знач.)',
          sortable: true
        },
        {
          key: 'categoryName',
          label: 'Категория переводимых данных',
          sortable: true
        },
      ],
      currentPage: 1,
      currentSort: 'id',
      currentSortDir: 'asc',
      searchVal: '',
      oldType: 'ru',
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'GET_TYPE',
      'GET_CATEGORY',
      'SAVE',
    ]),
    goToPage: function (page) {
      if (this.checkIsChange()) {
        return false;
      }
      this.$store.commit('translations/dictionary/CURRENT_PAGE', page);
      this.GET_DATA({th: this});
    },
    perPage: function (perPage) {
      if (this.checkIsChange()) {
        return false;
      }
      this.$store.commit('translations/dictionary/PER_PAGE', perPage);
      this.GET_DATA({th: this});
    },
    initPageSize: function () {
      let winHeight = window.innerHeight;
      winHeight = Math.round((winHeight - 230) / 26);
      this.$store.commit('translations/dictionary/PER_PAGE', winHeight);
      this.currentPage = 1;
    },
    changeType: function () {
      if (this.checkIsChange()) {
        this.type = this.oldType;
        return false;
      }
      this.oldType = this.type;
      this.GET_DATA({th: this});
    },
    editCell: function (index, field) {
      let viewCell = this.$refs.dictionaryTable.$el.querySelectorAll('.t-cell');
      viewCell.forEach((val) => {
        val.style.display = 'block';
      });

      let editCell  = this.$refs.dictionaryTable.$el.querySelectorAll('.edit-cell');
      editCell.forEach((val) => {
        val.style.display = 'none';
      })

      this.$refs['cell_view_' + index +'_'+ field].style.display = 'none';
      if (this.$refs['cell_edit_' + index +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + index +'_'+ field].style.display = 'block';
        this.$refs['cell_edit_' + index +'_'+ field].focus();
      } else {
        this.$refs['cell_edit_' + index +'_'+ field].$el.style.display = 'block';
        this.$refs['cell_edit_' + index +'_'+ field].$el.focus();
      }
    },
    changeCell: function (index, field) {
      this.$refs['cell_view_' + index +'_'+ field].style.display = 'block';
      if (this.$refs['cell_edit_' + index +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + index +'_'+ field].style.display = 'none';
      } else {
        this.$refs['cell_edit_' + index +'_'+ field].$el.style.display = 'none';
      }
      this.$store.commit('translations/dictionary/EXIST_CHANGE', true);
      // add new row
      if (this.DICTIONARY_DATA.length == (index + 1)) {
        let buf = this.DICTIONARY_DATA.splice(0);
        buf.push({
          id: '--',
          singularKey: '',
          singularValue: '',
          pluralKey: '',
          pluralValue: '',
          categoryName: '',
        });
        this.$store.commit('translations/dictionary/DICTIONARY_DATA', buf);
        this.$forceUpdate();
      }
    },
    removeRow: function (id) {
      let buf = this.DICTIONARY_DATA.filter((el) => {
        if (el.id == id) {
          this.$store.commit('translations/dictionary/ADD_TO_DELETED_LIST', id);
        }

        return el.id != id;
      });
      this.$store.commit('translations/dictionary/DICTIONARY_DATA', buf);
      this.$store.commit('translations/dictionary/EXIST_CHANGE', true);
    },
    save: function () {
      this.SAVE({th: this});
    },
    sortingChanged: function (ctx) {
      if (this.checkIsChange()) {
        return false;
      }
      let buf = Object.assign({}, this.PARAMS);
      buf.sort = {
        dir: ctx.sortDesc ? 'desc' : 'asc',
        field: ctx.sortBy
      };
      this.$store.commit('translations/dictionary/PARAMS', buf);
      this.GET_DATA({th: this});
    },
    search: function () {
      if (this.checkIsChange()) {
        return false;
      }
      this.searchChange();
      this.GET_DATA({th: this});
    },
    searchChange: function () {
      let buf = Object.assign({}, this.PARAMS);
      buf.search = this.searchVal;
      this.$store.commit('translations/dictionary/PARAMS', buf);
    },
    checkIsChange: function () {
      if (this.EXIST_CHANGE) {
        this.$bvModal.show('noSaveWarning');
        // this.$bvModal.show('infoMessage');
        return true;
      }
      return false;
    },
    changeIgnore: function () {
      this.$store.commit('translations/dictionary/EXIST_CHANGE', false);
    }
  },
  computed: {
    ...mapGetters([
      'DICTIONARY_DATA',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'AMOUNT_PAGE',
      'TYPE_LIST',
      'CATEGORY_LIST',
      'SELECTED_TYPE',
      'PARAMS',
      'EXIST_CHANGE',
    ]),
  },
  watch: {
    currentPage(newVal) {
      this.$store.commit('translations/dictionary/CURRENT_PAGE', newVal);
    },
    type(newVal) {
      this.$store.commit('translations/dictionary/SELECTED_TYPE', newVal);
    }
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('translations') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.currentPage = this.CURRENT_PAGE;
    this.type = this.SELECTED_TYPE;
  },
  created() {
    this.initPageSize();
    if (this.TYPE_LIST.length == 0) {
      this.GET_TYPE({th: this});
    }
    if (this.CATEGORY_LIST.length == 0) {
      this.GET_CATEGORY({th: this});
    }
    if (this.DICTIONARY_DATA.length == 0) {
      this.GET_DATA({th: this});
    }
  }
}
</script>

<style scoped>
  .dictionary-type {
    width: 77px;
    float: right;
  }
  .cell-cursor {
    cursor: cell;
  }
  .t-cell {
    overflow: hidden;
    width: 100%;
    display: block;
  }
  .remove-button {
    float: left;
    height: 24px;
    line-height: 15px;
  }
  .save-but {
    float: right;
  }
  .search-box {
    width: 300px;
    float: left;
  }
  .edit-cell {
    height: 24px;
    line-height: 15px;
  }
</style>